import { defineMessage } from 'services/localization';

export const messages = {
    warning: defineMessage('weve_temporarily_paused_vices_please_contact_us'),
    addonCaptureTitle: defineMessage('approvalmax_capture'),
    addonPayTitle: defineMessage('approvalmax_pay'),
    contactUsText: defineMessage('contact_support_1'),
};
